import { ComponentStyleConfig, createMultiStyleConfigHelpers } from '@chakra-ui/react';
import { cardAnatomy } from '@chakra-ui/anatomy';

const { definePartsStyle } = createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    borderRadius: 'card',
    bgColor: 'white',
    borderColor: 'white',
    shadow: 'cardSm',
  },
  header: {
    p: 'kilo',
  },
  body: {
    p: 'kilo',
    // background: 'red',
  },
});

export const card: ComponentStyleConfig = {
  defaultProps: {
    variant: 'outline',
  },
  baseStyle,
};
